import Button from '@berlitz/button'
import Spacer from '@berlitz/spacer'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { Wrapper } from './style'

interface Prop {
  onRetry: Function
  message?: string
}

const ViewMaterialError: React.FC<Prop> = ({ onRetry, message = 'An unknown error has occurred' }) => {
  const fallbackMessage = message || 'An unknown error has occurred'
  return (
    <Wrapper className="error">
      <span>
        <FormattedMessage id={fallbackMessage} />.
      </span>
      <Spacer size="xs" />
      <Button small onClick={onRetry}>
        <FormattedMessage id="Click here to retry" />
      </Button>
    </Wrapper>
  )
}

export default ViewMaterialError
